<template>
  <f7-page name="about">
    <f7-navbar title="feedback" back-link="Back">
      <f7-nav-right>
        <f7-link  href="/" class="menu-icon"><i class="az-icon-home-house-interface-ui-website"></i></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div class="feedback-content">
      <h1 class="feedback-title">Feedback</h1>
      <p>Thank you for attending our event</p>
      <div class="feedback-name">
        <p>Please submit your feedback below</p>
        <!-- <div class="feedback-name-block">Name</div> -->
      </div>
      <!-- Feedback Rating-->

      <!-- <h3 class="rating-text">Rating</h3> -->

      

      <!-- Rating Stars-->
      <div class="feedback-rate">
        <div class="rating">
          <star-rating v-model="rating"></star-rating>
        </div>
      </div>

      <!-- Feedback Button-->
      <div class="feedback-button">
        <div class="row">
          <!-- <f7-col width="15"></f7-col> -->
          <f7-col width="100">
            <a @click="saveFeedBack" href="#" class="button button-fill button-round">Send Feedback</a>
          </f7-col>
          <!-- <f7-col width="15"></f7-col> -->
        </div>
      </div>
    </div>

  </f7-page>
</template>
<script>
import StarRating from 'vue-star-rating'
export default {
  components: {
    StarRating
  },
  data() {
    return {
      rating: 0
    }
  },
  methods: {
    saveFeedBack: function() {
      this.$f7.preloader.show()

      var event = JSON.parse(sessionStorage.getItem('currentEvent'))
      var data = {
        rating: this.rating,
        event_id: event.id
      }

      this.$http.post( this.$root.apiBaseURL + 'save-feedback', data )
        .then( (res) => {
          this.$f7.preloader.hide()
          this.$f7.dialog.alert('Thank you for your feedback', 'Thanks')
          this.$f7.view.current.router.navigate( '/event-details/'+ event.id )
          localStorage.setItem('feed_back_event_' + event.id, 'yes')
        })
        .catch( (err) => {
          this.$f7.preloader.hide()
          console.log( err )
        })
    }
  },
  mounted: function() {
    var event = JSON.parse(sessionStorage.getItem('currentEvent'))

    if( localStorage.getItem('feed_back_event_' + event.id ) ) {
      this.$f7.view.current.router.navigate( '/' )
    }
  }
}
</script>
<style scoped>
  .menu-icon i::before {
    color: #870047;
    font-size: 35px;
  }
</style>
